import { useState, useRef, useEffect } from "react";
import classes from "./styles.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getSvgUrl } from "../../../utils/imageUtils";
import { logout } from "../../../redux/slices/auth";
import { toggleTheme } from "../../../redux/slices/theme";
import { isDarkModeAllowed } from "../../../config/routePermissions";
import ConfirmModal from "../../../components/confirmModal/ConfirmModal";
import MobileHamburger from "../mobileHam";
import NotificationCard from "../../../components/notificationCard";
import ThemeToggle from "../../../components/themeToggle";

const BellIcon = getSvgUrl("bell");

const RightContent = ({ expand, children }) => {

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const themeMode = useSelector((state) => state.theme.mode);
  const role = useSelector((state) => state.auth.role);
  const showThemeToggle = isDarkModeAllowed(role, location.pathname);

  const isAdminDashboard = location.pathname.startsWith("/admin/map-dashboard") || location.pathname.startsWith("/admin/retailer-map");


  const { pathname } = location;
  const firstPath = pathname.split("/").filter(Boolean)[0] || "";

  let headerText = firstPath
    ? firstPath
      .replace(/-/g, " ")
      .split(" ")
      .map(
        (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join(" ")
    : "Dashboard";

  headerText = headerText === "Icccmaster" ? "ICCC Master" : headerText;

  const handleLogout = () => {
    console.log("🔓 [RightContent] Logging out user...");
    dispatch(logout());
    navigate("/");
  };

  const handleCloseLogoutModal = () => {
    setIsLogoutModalOpen(false);
  };

  const [showNotification, setShowNotification] = useState(false);
  const notificationRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(e.target)
      ) {
        setShowNotification(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className={`
        ${classes.right_container} 
        ${expand ? classes.expand : ""}
        ${isAdminDashboard ? classes.show_hide_on_map : ""}
      `}
    >
      <header className={classes.header}>
        <div className={classes.left_header}>
          <MobileHamburger />
          {!isAdminDashboard &&
            <p className={classes.header_text}>
              {headerText}
              {headerText !== "Dashboard" ? " Module" : ""}
            </p>
          }
          {isAdminDashboard &&
            <p className={classes.header_text_new}>
              <img src={getSvgUrl("newBlackLogo")} alt="logo" /> Dashboard
            </p>
          }
        </div>
        <div className={classes.right_logout_notification}>
          {showThemeToggle && (
            <ThemeToggle
              mode={themeMode}
              onToggle={() => dispatch(toggleTheme())}
            />
          )}
          <div className={classes.notification_wrapper}>
            <button
              className={classes.notification_icon}
            >
              <img src={BellIcon} alt="icon" className={classes.bell} />
              <div className={classes.dot}></div>
            </button>

            {showNotification && (
              <div
                ref={notificationRef}
                className={classes.notification_list_wrapper}
              >
                <p className={classes.notify_header}>Notifications</p>
                <div className={classes.notify_cards}>
                  <NotificationCard
                    notify_header="Heading"
                    old_new_status="New"
                    notification_text="Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur ma orem ipsum dolor sit amet,"
                    notification_time="12:08 PM"
                  />
                  <NotificationCard notify_header="Heading" />
                  <NotificationCard notify_header="Heading" />
                  <NotificationCard notify_header="Heading" />
                  <NotificationCard notify_header="Heading" />
                  <NotificationCard notify_header="Heading" />
                </div>
              </div>
            )}
          </div>
          <button
            className={classes.logout_button}
            onClick={() => setIsLogoutModalOpen(true)}
          >
            <img src={getSvgUrl("logout")} alt="icon" className={classes.log_out} />
            <span>Logout</span>
          </button>
        </div>
      </header>

      <div className={classes.main_content}>{children}</div>

      <div className={classes.footer} data-app-footer>
        <div className={classes.footer_text}>
          For any technical assistance, kindly contact us on 7761037772.
        </div>
      </div>

      <ConfirmModal
        isOpen={isLogoutModalOpen}
        message={"Are you sure you want to logout"}
        onYes={handleLogout}
        onClose={handleCloseLogoutModal}
        title={"Confirm Logout"}
      />
    </div>
  );
};

RightContent.propTypes = {
  children: PropTypes.node,
  expand: PropTypes.bool,
};

export default RightContent;
